module.exports = __webpack_public_path__ + "img/LanghamEatonDCBanner.cd2a6aa0.png";